const metrics = [
  { value: "24h", label: "Devis réalisé sous 24h", sub: "Réponse rapide garantie" },
  { value: "+15", label: "Années d'expertise DSP", sub: "Savoir-faire artisanal" },
  { value: "48h", label: "Délai moyen d'intervention", sub: "Réactivité garantie" },
  { value: "100%", label: "Garantie constructeur préservée", sub: "Peinture d'origine" },
];

export const Metrics = () => {
  return (
    <section
      id="chiffres"
      data-testid="metrics-section"
      className="relative bg-[#007AFF] text-white py-24 md:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 grid-pattern opacity-20" />
      <div className="noise-overlay" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-16">
          <div className="text-xs font-bold uppercase tracking-[0.3em] text-white/70 mb-4">
            — PDR France en chiffres
          </div>
          <h2
            data-testid="metrics-title"
            className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tighter leading-[0.95]"
          >
            La référence<br />du <span className="text-[#EF4135]">DSP</span> en France
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/20 border border-white/20">
          {metrics.map((m, i) => (
            <div
              key={i}
              data-testid={`metric-${i}`}
              className="bg-[#007AFF] p-8 md:p-10 flex flex-col justify-between min-h-[220px] hover:bg-[#0056CC] transition-colors"
            >
              <div className="font-heading text-6xl md:text-7xl lg:text-8xl font-black tracking-tighter leading-none">
                {m.value}
              </div>
              <div className="mt-8">
                <div className="font-semibold text-white leading-tight">
                  {m.label}
                </div>
                <div className="text-xs uppercase tracking-widest text-white/70 mt-2">
                  {m.sub}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
